var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeddingBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V8.64494C19.6831 8.55064 19.3475 8.5 19 8.5H18V6C18 5.44772 17.5523 5 17 5H14C13.4477 5 13 5.44772 13 6V8.5H11V6C11 5.44772 10.5523 5 10 5H7C6.44772 5 6 5.44772 6 6V8.5H5C4.65251 8.5 4.31685 8.55064 4 8.64494V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C3.89543 10 3 10.8954 3 12C2.44772 12 2 12.4477 2 13V19C2 19.5523 2.44772 20 3 20V21C3 21.5523 3.44772 22 4 22H5C5.55228 22 6 21.5523 6 21V20H18V21C18 21.5523 18.4477 22 19 22H20C20.5523 22 21 21.5523 21 21V20C21.5523 20 22 19.5523 22 19V13C22 12.4477 21.5523 12 21 12C21 10.8954 20.1046 10 19 10H5ZM9 14.7549C9 13.0243 10.65 12.3782 12 13.715C13.35 12.3782 15 13.0243 15 14.7549C15 15.7908 13.7942 16.8864 12.9115 17.5496C12.5119 17.8499 12.3121 18 12 18C11.6879 18 11.4881 17.8499 11.0885 17.5496C10.2058 16.8864 9 15.7908 9 14.7549Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingBed);
export default __webpack_public_path__ + "static/media/wedding-bed.dfae4a69e7bfc01b54a9ca96ebf65a9f.svg";
export { ForwardRef as ReactComponent };